export {
  HoverColor,
  IconBackdrop,
  IconColor,
  IconSize,
} from './icon.component';
export { IconModule } from './icon.module';
